import { render } from "./CreateHonor.vue?vue&type=template&id=390fea52&scoped=true"
import script from "./CreateHonor.vue?vue&type=script&lang=js"
export * from "./CreateHonor.vue?vue&type=script&lang=js"

import "./CreateHonor.vue?vue&type=style&index=0&id=390fea52&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390fea52"]])

export default __exports__